import React from 'react';
import PropTypes from 'prop-types';
import { truncateNumber, urlEncode } from '../../utilities/Utils';

function RisesOrFallsTable(props)
{
    const { data, title, iconCssClasses} = props;

    let changeValue = 0;

    return (
        <div className="changes-table">
            <h3>{title}<span className={`icon ${iconCssClasses}`}></span></h3>
            {data.length === 0 ? (
                <div className='text-center p-3 pt-4'>
                    <span className='icon error-data'>&nbsp;</span>
                    <div className='text-uppercase pt-2'>
                        <p className='mb-0'>There are currently</p>
                        <p>no {title} to display</p>
                    </div>
                    <p>Or trading is closed</p>
                </div>
            ) : (
                <table>
                    <thead>
                    <tr>
                        <th>
                            <p>Security code</p>
                            <p>Security name</p>
                        </th>
                        <th>
                            <p>Market value</p>
                            <p>Total change</p>
                        </th>
                        <th />
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((index, key) => (
                        <tr key={key} >
                            <td>
                                <p><a href={urlEncode(`${window.location.pathname.replace(/\/$/, '')}/${index.instrumentId}`)}>{index.tickerSymbol}</a></p>
                                <p>{index.name}</p>
                            </td>
                            <td>
                                <p>{`${truncateNumber(index.closeValue.amount)} ${index.closeValue.currency}`}</p>
                                <p className="no-wrap">{`${((changeValue = truncateNumber(index.changeValue.amount)) > 0) ? (`+${changeValue}`) : changeValue} (${(Math.abs(index.changePercentage)).toFixed(2)}%)`}</p>
                            </td>
                            <td className="indicator" width="32"><span className={`icon ${changeValue == 0 ? 'dash' : iconCssClasses}`}></span></td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

RisesOrFallsTable.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    iconCssClasses: PropTypes.string,
};

export default RisesOrFallsTable;
